// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-card[data-v-8c3350e0]{border-radius:20px}.close-icon[data-v-8c3350e0]{position:absolute!important;cursor:pointer;top:12px;right:12px;background-color:hsla(0,0%,100%,.15);border-radius:50%;padding:7px}", ""]);
// Exports
module.exports = exports;
